import { useState, useEffect } from 'react';
import { EMENDA_TYPES } from '../../utils/emendas/constants';
import { useEmendasData } from './useEmendasData';

/**
 * Hook para carregar dados de ambos os tipos de emendas simultaneamente
 * Útil para calcular estatísticas unificadas (anos presentes em qualquer tipo)
 * @returns {Object} { municipalData, municipalColumns, estadualData, estadualColumns, loading, error }
 */
export const useAllEmendasData = () => {
  const [allData, setAllData] = useState({
    municipalData: [],
    municipalColumns: [],
    estadualData: [],
    estadualColumns: [],
    loading: true,
    error: null
  });

  // Carregar dados municipais
  const municipal = useEmendasData(EMENDA_TYPES.MUNICIPAL);
  
  // Carregar dados estaduais
  const estadual = useEmendasData(EMENDA_TYPES.ESTADUAL);

  useEffect(() => {
    // Atualizar estado quando ambos os dados estiverem carregados
    setAllData({
      municipalData: municipal.data,
      municipalColumns: municipal.columns,
      estadualData: estadual.data,
      estadualColumns: estadual.columns,
      loading: municipal.loading || estadual.loading,
      error: municipal.error || estadual.error
    });
  }, [
    municipal.data,
    municipal.columns,
    municipal.loading,
    municipal.error,
    estadual.data,
    estadual.columns,
    estadual.loading,
    estadual.error
  ]);

  return allData;
};
